
// import builderFunctions from '@/builder/BuilderFunctions'
let api = {
}

api.setClientAPI = (a) => { api.rootNode = a.getSchema() }

api.isString = (s) => {
    return s && typeof (s) === 'string' || s instanceof String;
}

api.isFunction = (obj) => {
    return typeof obj === "function"
}

api.generateUUID = () => {
    var buf = new Uint32Array(4);
    window.crypto.getRandomValues(buf);
    var idx = -1;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (
        c
    ) {
        idx++;
        var r = (buf[idx >> 3] >> ((idx % 8) * 4)) & 15;
        var v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

api.hash = (str) => {
    var hash = 0,
        i, chr;
    if (str.length === 0) return hash;
    for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return Math.abs(hash);
}

api.evalExpression = (e, scope, ...params) => {
    if (!api.isString(e)) return e

    const isVueInstance = scope && typeof scope === 'object' && (
        !!scope._uid
        || !!scope.$el
        || !!scope.$root
        || !!scope.$options
    )

    scope = isVueInstance
        ? scope
        : window.api.getComponent(scope?.nodeUUID ? scope : null)
            || window.api.getComponent(scope?.instanceName)
            || window.api.getComponent(scope?.instance_name)
            || window.api.getComponent(scope?.propsData?.instanceName)
            || window.api.getComponent(scope?.propsData?.instance_name)
            || window.api.getComponent(scope?.name)
            || scope

    e = api.applyUnderscores(e)
    e = api.applyBraces(e)

    function evalInScope(js, contextAsScope, ...params) {
        return new Function(`with (this) { return (${js}); }`).call(contextAsScope, ...params);
    }

    e = e.trim()

    /**
     * acepta expresiones del tipo
     *
     *     () => { return 55 }
     *     (a) => { return a * 2}
     *
     * No acepta cosas como
     *
     *     { return 4; }
     *     (a) => 5
     */

    try {
        const regexpArrowFunction = /(.*?) => {.*?}/g;
        if (regexpArrowFunction.test(e)) {
            e = e.replace(/\\(\\)\s=>\s\\{|\\}$/,"")
            // MAL! Debiera ser e = evalInScope(e, scope)(params) pero tocar esto ahora implica revisar TODOs los formularios y componentes uno a uno.
            // esto solo se nota en aquellos componentes que hacen api.eval(expr, valor_a_la_funcion), porque this es undefined.
            // habria que reprogramarlos a api.eval(expr, this, valor_a_la_funcion) para que this este definido.
            e = evalInScope(e, scope)(...params)
            return e
        }

        const regexpArrowFunction2 = /(.*?)(\s)*=>(\s)*.*/g;
        if (regexpArrowFunction2.test(e)) {
            const parts = e.split("=>")
            const left = parts[0]
            const right = parts.slice(1).join('=>').trim()

            if (right.startsWith('{')) {
                e = left + ' => ' + right
            } else {
                e = left + ' => { return ' + right + '}'
            }

            // igual que arriba. debiera rezar e = evalInScope(e, scope)(params)
            e = evalInScope(e, scope)(...params)
            return e
        }
    } catch (err) {
        console.error('Error evaluando la expresion: ', e, params)
        throw err
    }

    return e
}

api.evalObject = (obj, scope, ...params) => {
    if (Array.isArray(obj)) {
        return obj.map(item => api.evalObject(item, scope, ...params))
    }

    if (!obj || typeof obj !== 'object') {
        return api.evalExpression(obj, scope, ...params)
    }

    return Object.keys(obj).reduce((result, key) => {
        result[key] = api.evalObject(obj[key], scope, ...params)
        return result
    }, {})
}

api.applyBraces = (e) => {
    if (!api.isString(e)) return e

    return e.replace(/\{\{.*?\}\}/g, match => {
        let s = match.substring(2, match.length - 2);
        return eval(s)
    })
}

api.applyUnderscores = (e) => {
    if (!api.isString(e)) return e

    if(!e.includes('__')) return e
    if(e.includes('__(')) return e
    if ( e.includes('=>') && e.indexOf('=>') < 10 ) return e

    return e.replace(/__.*?__/g, match => {
        let s = match.substring(2, match.length - 2);
        let r = window.api.get(s) || ''
        // window.console.log('ESR ***********************', e, s, r)

        return r.label || r
    })
}

/**
 * Carga el fichero en el elemento HTML indicado y llama el callback con el contenido.
 * @param {*} elementID
 * @param {*} onload
 * @param {*} onerror
 */
api.getHTMLInputFileContentCB = (elementID, onload, onerror) => {
    var file = document.getElementById(elementID).files[0];
    window.console.log('file>', elementID, file);

    if (file) {
        var reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onload = function (evt) {
            if (onload) onload(evt.target.result)
        }
        reader.onerror = function (evt) {
            window.console.log('error cargando fichero!');
            if (onerror) onerror(evt)
        }
    } else {
        window.console.log('Error en getHTMLInputFileContent. El fichero ' + elementID + ' no se ha seleccionado.')
        if (onerror) onerror('El fichero ' + elementID + ' no se ha seleccionado.')
    }
}

api.getHTMLInputFileContent = (elementID) => {
    return new Promise((resolve, reject) => {
        api.getHTMLInputFileContentCB(elementID, resolve, reject)
    })
}

/**
 * Se usa para eliminar c:/fakepath
 *
 * @param {*} path
 * @returns El nombre real del fichero
 */
api.getFilename = (elementName) => (window.api.get(elementName) || '').match(/[^\\/]*$/)[0];

window.evalExpression = api.evalExpression

export default api
